import { useSearchParams } from 'react-router-dom';
import { useCurrentTemplateId } from 'hooks/path-params-extraction.hooks';
import { useGetBlueprint } from 'stores/rq/blueprints';
import { getTemplateProjectScopeId } from 'utils/template.utils';
import type { PermissionProjectScopeResolution } from 'components/routes/routes.types';

export const useTemplatePermissionProjectScope = (): PermissionProjectScopeResolution => {
  const [searchParams] = useSearchParams();
  const templateId = useCurrentTemplateId();
  const { data: template, isPending } = useGetBlueprint(templateId);

  const projectIdFromUrl = searchParams.get('projectScope') ?? undefined;

  if (!templateId) return { projectId: projectIdFromUrl, isResolving: false };
  if (isPending) return { projectId: undefined, isResolving: true };

  return { projectId: getTemplateProjectScopeId(template), isResolving: false };
};
